var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.05009 3.80694C9.7971 3.59873 11.5642 3.96807 13.0817 4.85856C14.5991 5.74906 15.7834 7.11176 16.4537 8.73859C16.5162 8.90699 16.5162 9.09223 16.4537 9.26063C16.1781 9.92893 15.8138 10.5571 15.3707 11.1283M10.5631 10.6186C10.1388 11.0285 9.57041 11.2553 8.98048 11.2502C8.39054 11.2451 7.82622 11.0084 7.40906 10.5912C6.9919 10.174 6.75527 9.60965 6.75014 9.01967C6.74502 8.42968 6.9718 7.86128 7.38165 7.43689M13.1089 13.1244C12.114 13.7138 11.004 14.0823 9.85418 14.2048C8.70437 14.3273 7.54166 14.2011 6.44493 13.8346C5.34821 13.4682 4.34313 12.8701 3.49791 12.0809C2.65268 11.2917 1.98709 10.33 1.54628 9.26086C1.48377 9.09246 1.48377 8.90722 1.54628 8.73882C2.21124 7.12608 3.38126 5.77252 4.88073 4.88126M1.50013 1.4994L16.4999 16.5006",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/icon-eye-off.7235f829e98c3c480d7be29b146aa32b.svg";
export { ForwardRef as ReactComponent };